import { returnToNativeShell } from './../../core/nativeShell.js';

require('./app_slider.js');
require('./slider_service.js');
require('./send_invite_service.js');
require('./../../gh_elements/radio_button/radio_button_data.js')
require('../../config.js');


angular.module('applicationsCtrlMod', [
        'pipeModule',
        'ghAppSlider',
        'sliderModule',
        'sendingInviteModule'
    ])


    /*=======================================================================================================*/
    /*==============================   APPLICATIONS MANAGER CONTROLLER   ====================================*/
    /*=======================================================================================================*/
    .controller('ApplicationsCtrl', ['$location', '$scope', 'authService', 'authApi', '$window', 'storage', 'PipeService','$q', 'sliderService', 'cnfg', 'localizationService', '$mdMedia', function($location, $scope, authService, authApi, $window, storage, PipeService, $q, sliderService, cnfg, localizationService, $mdMedia) {

        const dictionary = localizationService.getDictionary('account_settings');
        $scope.translate = (word) => localizationService.translate(word, dictionary);
        $scope.changePath = function(path){
            $location.path(path);
        }

        $scope.avatarClick = function(){
            if ($mdMedia('max-width: 767px')) {
                $scope.changePath('/usersettings');
            } else {
                $scope.open_ropdown = !$scope.open_ropdown;
            }
        }

        //--Logo in applist in the left App corner, cnfg.logo_id is set in .env file in LOGO_ID variable
        $scope.logoId = cnfg.logo_id; 
        
        //-- Show App Constructor button in the left top corner of app slider, cnfg.show_app_constructor is set in .env file in SHOW_APP_CONSTRUCTOR variable
        $scope.showAppConstructor = cnfg.show_app_constructor;

        //-- Show Invite button in the top menu, cnfg.show_invite_button is set in .env file in SHOW_INVITE_BUTTON variable
        $scope.showInviteButton = cnfg.show_invite_button;

        //-- Background class for applications list page. 
        // The list of background classes is defined in gui/gh_background/gh_background.scss
        $scope.backgroundClass = storage.getUser().background || 'blue_stains';
       
        //********* Preview Mode  *************/
        // Preview mode is needed to demonstrate GugHub in Iframe on a webpage. In this mode some functions are limited, for example, menu with user are hided and pencil removed
        // This need in preview mode in component
        $scope.previewMode = false;
        if($location.$$host === 'preview.gudhub.com' || $location.$$search.preview == 'true') {
            $scope.previewMode = true;
            window.parent.postMessage('preview-loaded', '*');
        }
        //**************************************/

        var appUrl = $location.url();

        angular.extend($scope, {
            tabs: [],
            removing_show: false
        });
        var itemPerTab = 0;

        
        $scope.userModel = {
            data_model: {
                photo_size: 128,
                interpetation: [{
                    src: 'table',
                    id: 'photo_full_name',
                    settings: {
                        editable: 0,
                        show_field_name: 0,
                        show_field: 1
                    }
                }]
            },
            data_type: 'user',
            field_value: angular.copy(storage.getUser().user_id)
        };



        $scope.logout = function() {
            authService.getToken().then(function(accessToken) {
                return authApi.logout(accessToken);
            }).then(function() {
                $window.localStorage.clear();
                storage.unsetUser();
                storage.unsetApps();
                gudhub.appProcessor.clearAppProcessor();

                // In the mobile app the key also lives in native storage;
                // clearing only localStorage would sign the user straight back
                // in on the next cold start.
                if (returnToNativeShell()) return;

                window.location.replace(cnfg.file_server_url + '/login');
                $scope.$apply();
            });
        };

        // Delete application
        $scope.deleteApp = function(appId) {
            PipeService.emit('gh_delete_app', {}, { 
                app_id: appId
            });
        };

        $scope.closeDropdown = function() {
            $scope.open_ropdown = false;
        };

        $scope.$evalAsync(function() {
            $scope.removing_show = false;
            $scope.removing_show_pencil = false;
        });

    }])


    /* -- Filter apps list by range --*/
    .filter('limitFromTo', function() {
        return function(apps, from, to) {
            return (apps != undefined) ? apps.slice(from, to) : '';
        };
    });
